export enum TaskListId {
  All = "all",
  My = "my",
  Coop = "coop",
}
